import React from 'react';
import styled from 'styled-components';

import { Logo } from './LinkLogo';

import footerBg from '../../images/welcome-teachers/blue-wave.svg';
import { Container } from '../Container';
import { SocialButtons } from '../new/SocialButtons';

const FooterWrapper = styled.div`
    height: 278px;
    background-image: url(${footerBg});
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: cover;

    @media screen and (max-width: 760px) {
        height: auto;
        padding-bottom: 24px;
        padding-top: 48px;
        box-sizing: border-box;
    }
`;

const FooterInner = styled.div`
    display: flex;
    align-items: flex-start;
    padding-top: 104px;
    box-sizing: border-box;
    flex-direction: column;
    width: 100%;
    @media screen and (max-width: 760px) {
        padding-top: 120px;
    }
`;

const InfoWrap = styled.div`
    display: flex;
    align-items: center;
    margin: 32px 0 0;
    width: 100%;
    min-height: 3rem;

    @media screen and (max-width: 760px) {
        flex-direction: column;
        align-items: flex-start;
        margin: 12px 0 12px;
    }

    .info-wrap__link {
        font-family: 'Circe Web';
        font-size: 18px;
        line-height: 27px;
        color: #fff;

        & + .info-wrap__link {
            margin-left: 32px;

            @media screen and (max-width: 760px) {
                margin: 16px 0 0;
            }
        }

        &:hover {
            text-decoration: underline;
        }
    }
`;
const DocumentsWrap = styled(InfoWrap)`
    margin: 0;

    .info-wrap__link {
        font-size: 14px;
        opacity: 0.7;
        margin: 0 24px 0 0;
        & + .info-wrap__link {
            margin-left: 0;
        }
        @media screen and (max-width: 760px) {
            order: 2;
        }
    }
`;

const SocialWrapper = styled.div`
    margin-left: auto;
    align-self: flex-start;
    align-items: center;

    & > a:first-child {
        margin-left: -0.2rem;
    }
    @media screen and (max-width: 760px) {
        order: 1;
        margin: 0 0 3rem;
    }
`;

export const Footer = () => (
    <FooterWrapper>
        <Container>
            <FooterInner>
                <Logo height="32" color="white" />
                <InfoWrap>
                    <a
                        href="mailto:student@kespa.ru"
                        className="info-wrap__link"
                    >
                        student@kespa.ru
                    </a>
                    <a href="tel:+74950551756" className="info-wrap__link">
                        +7 (499) 647-60-44
                    </a>
                    <a
                        href="https://teleg.run/KespaSchoolBot"
                        className="info-wrap__link"
                    >
                        TG: KespaSchoolBot
                    </a>
                </InfoWrap>
                <DocumentsWrap>
                    <a href="/offer" className="info-wrap__link">
                        Договор-оферта
                    </a>
                    <a href="/privacy" className="info-wrap__link">
                        Соглашение о конфиденциальности
                    </a>
                    <SocialWrapper>
                        <SocialButtons fb yt color="white" />
                    </SocialWrapper>
                </DocumentsWrap>
            </FooterInner>
        </Container>
    </FooterWrapper>
);
